var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9452",
    className: "st0",
    d: "M42,41.6H6c-3.2-0.1-5.6-2.8-5.5-6V12.4C0.4,9.2,2.9,6.6,6,6.4H42c3.2,0.1,5.6,2.8,5.5,6v23.1 C47.6,38.8,45.1,41.4,42,41.6z M6,9.3c-1.7,0.1-3,1.5-2.9,3.2v23.1c-0.1,1.7,1.2,3.1,2.9,3.2H42c1.7-0.1,3-1.5,2.9-3.2V12.4 c0.1-1.7-1.2-3.1-2.9-3.2H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9453",
    className: "st0",
    d: "M17.2,32.5c-0.9,0-1.6-0.8-1.5-1.7V18.3c0-0.6,0.3-1.1,0.7-1.4c0.4-0.3,1-0.4,1.5-0.1l12.3,6 c0.9,0.5,1.2,1.6,0.7,2.4c-0.2,0.3-0.4,0.5-0.7,0.7l-12.3,6.6C17.7,32.5,17.5,32.5,17.2,32.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default __webpack_public_path__ + "static/media/Tutorials.0af01c39a7da6740d0e4b0079308e1ff.svg";
export { ForwardRef as ReactComponent };